import { render, staticRenderFns } from "./returnMedici.vue?vue&type=template&id=67594394&scoped=true"
import script from "./returnMedici.vue?vue&type=script&lang=js"
export * from "./returnMedici.vue?vue&type=script&lang=js"
import style0 from "./returnMedici.vue?vue&type=style&index=0&id=67594394&prod&lang=less&scoped=true"
import style1 from "./returnMedici.vue?vue&type=style&index=1&id=67594394&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67594394",
  null
  
)

export default component.exports